import React from 'react';
import { classNames } from '@fullstory/util/fmt';
import css from './pagination.module.scss';
import { FormattedMessage } from 'react-intl';
import { IconButton } from '@fullstory/components';
import { intl } from '@fullstory/intl';

interface PaginationProps {
  page: number;
  totalPages: number;
  onNextPage: (page: number) => void;
  onPrevPage: (page: number) => void;
  className?: string;
}

class Pagination extends React.Component<PaginationProps> {
  constructor(props: PaginationProps) {
    super(props);
  }

  onNextPage = (page: number) => {
    if (page < this.props.totalPages - 1) {
      this.props.onNextPage(page + 1);
    }
  };

  onPrevPage = (page: number) => {
    if (page >= 1) {
      this.props.onPrevPage(page - 1);
    }
  };

  render() {
    const rightDone = this.props.page >= this.props.totalPages - 1;
    const leftDone = this.props.page <= 0;
    const handlePrev = () => this.onPrevPage(this.props.page);
    const handleNext = () => this.onNextPage(this.props.page);

    return (
      <div
        data-component="Pagination"
        className={classNames(css.compPagination, this.props.className)}
      >
        <IconButton
          testId="page-left"
          disabled={leftDone}
          iconName="chevron-left"
          onClick={handlePrev}
          onKeyDown={enterKeydownHandler(handlePrev)}
          size="large"
          title={intl.formatMessage({ defaultMessage: 'Previous page', id: 'k9hDFZ' })}
        />
        <div className={css.pages}>
          <FormattedMessage
            defaultMessage="{page, number} of {total, number}"
            id="g2UYTU"
            description="Pagination control displays current and total pages between left(previous) and right(next) arrow buttons. Ex: <-  2 of 11  ->"
            values={{ page: this.props.page + 1, total: this.props.totalPages }}
          />
        </div>
        <IconButton
          testId="page-right"
          disabled={rightDone}
          iconName="chevron-right"
          onClick={handleNext}
          onKeyDown={enterKeydownHandler(handleNext)}
          size="large"
          title={intl.formatMessage({ defaultMessage: 'Next page', id: 'rBj9Ib' })}
        />
      </div>
    );
  }
}

const enterKeydownHandler = (fn: () => void) => (e: React.KeyboardEvent) => {
  if (e.key === 'Enter') {
    fn();
  }
};

export { Pagination };
export type { PaginationProps };
